module.exports = __webpack_public_path__ + "static/media/location-slash.f6adb1bc.svg";